import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { ISublistDto } from "../../../pages/list-page/interface/dto/sublist.dto";
import { get } from "../../../service/api";

export const getSublist = (
    listId: number,
    tokens: ITokenPair,
): Observable<Array<ISublistDto>> =>
    get<Array<ISublistDto>>(`/lists/sublists/${listId}`, undefined, tokens);
